// extracted by mini-css-extract-plugin
module.exports = {"addtocart":"AddToCart-module--addtocart--96NUq","saveforlater":"AddToCart-module--saveforlater--19cTh"};